// ** React Imports
import {
    Link,
    //  Link,
    useHistory,
} from "react-router-dom";
// import { useEffect, useState } from "react";

// ** Custom Components
import Avatar from "@components/avatar";
import logoutIcon from "../../../../assets/images/logo/logout.svg";

// ** Utils

// ** Store & Actions
import { useDispatch } from "react-redux";
import { handleLogout } from "@store/authentication";
import { ApolloConsumer } from "react-apollo";
// ** Third Party Components
// import { User, Mail, CheckSquare, MessageSquare, Settings, CreditCard, HelpCircle, Power } from "react-feather";

// ** Reactstrap Imports
import {
    UncontrolledDropdown,
    // DropdownMenu,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
    //   DropdownItem
} from "reactstrap";

// ** Default Avatar Image
import defaultAvatar from "@src/assets/images/avatars/avatar-blank.png";
import { toast } from "react-toastify";
import { Settings } from "react-feather";

const UserDropdown = () => {
    const userData = JSON.parse(localStorage.getItem("UserRes"));
    let history = useHistory();
    // ** Store Vars
    const dispatch = useDispatch();

    // ** State

    //** ComponentDidMount

    //** Vars
    const signOut = (client) => {
        localStorage.clear();
        client.cache.reset();
        client.clearStore();
        dispatch(handleLogout());
        toast.success("Logout successfully");
        history.push("/signin");
    };

    return (
        <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
            <DropdownToggle href="/" tag="a" className="nav-link dropdown-user-link" onClick={(e) => e.preventDefault()}>
                <div className="user-nav d-sm-flex d-none">
                    <span className="user-name fw-bold">{userData?.SHORT_NAME}</span>
                    <span className="user-status">{userData?.DESIGNATION}</span>
                </div>
                <Avatar img={defaultAvatar} imgHeight="40" imgWidth="40" status="online" alt="" />
                <ApolloConsumer>
                    {(client) => (
                        <div>
                            <img
                                src={logoutIcon}
                                className="header-icon-width"
                                style={{ boxShadow: "none", background: "none" }}
                                onClick={() => signOut(client)}
                                alt=""
                            />
                        </div>
                    )}
                </ApolloConsumer>
            </DropdownToggle>

            {/*==== ONLY FOR SUPER ADMIN ====*/}
            {
                userData.PROFILE_ID === 'ADMIN' &&
                <DropdownMenu end>
                    <DropdownItem>
                        <Link to="/settings">
                            <Settings size={14} className='me-75' />
                            <span className='align-middle'>Settings</span>
                        </Link>
                    </DropdownItem>

                </DropdownMenu>
            }
        </UncontrolledDropdown>
    );

};

export default UserDropdown;
